<div class="content-blk">
  <div class="container">
    <h5 class="page-title">
      Report a Bug

    </h5>
    <p class="add-product-dashboard">
        Thank you so much for taking the time to report a bug.
        We are incredibly grateful for you as a customer.
        Though we strive to keep bugs down to a minimum sometimes they sneak through the cracks.
        If we have any further questions about this particular bug we'll reach out to you directly.
      <strong>- Team Merchloop</strong>
    </p>
    <form [formGroup]="reportBugForm" #formDirective="ngForm" (submit)="fn_SubmitBug(formDirective)" autocomplete="off">
      <div class="mat-crd-ui report-bug">
        <mat-card class="pad-16">
          <mat-card-content>
            <div class="example-form">
              <div class="row">
                <div class="col-sm-6">
                  <mat-form-field class="example-full-width">
                    <mat-label>Title</mat-label>
                    <input matInput formControlName="title" required>
                    <mat-error *ngIf="f.title.touched && f.title.invalid && f.title.pristine">
                      <strong>Required</strong>
                    </mat-error>
                    <mat-error *ngIf="!f.title.valid && (f.title.touched && f.title.dirty)">
                      <strong>Required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-6">
                  <mat-form-field class="example-full-width">
                    <mat-label>Page Url</mat-label>
                    <input matInput formControlName="pageUrl" required />
                    <mat-hint class="hint">URL of the page to report bug for.</mat-hint>
                    <mat-error *ngIf="f.pageUrl.touched && f.pageUrl.invalid && f.pageUrl.pristine">
                      <strong>Required</strong>
                    </mat-error>
                    <mat-error *ngIf="!f.pageUrl.valid && (!f.pageUrl.hasError('pattern') && f.pageUrl.touched && f.pageUrl.dirty)">
                      <strong>Required</strong>
                    </mat-error>
                    <mat-error *ngIf="!f.pageUrl.valid && (f.pageUrl.hasError('pattern') && f.pageUrl.dirty)">
                      Enter a valid Page URL
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <mat-form-field class="example-full-width">
                <mat-label>Description of the bug</mat-label>
                <textarea matInput formControlName="description" rows="6" required></textarea>
                <mat-hint class="hint">Detailed description of the bug including browser, OS version etc.</mat-hint>
                <mat-error *ngIf="f.description.touched && f.description.invalid && f.description.pristine">
                  <strong>Required</strong>
                </mat-error>
                <mat-error *ngIf="!f.description.valid && (f.description.touched && f.description.dirty)">
                  <strong>Required</strong>
                </mat-error>
              </mat-form-field>
              <mat-form-field class="example-full-width">
                <mat-label>Steps to Reproduce</mat-label>
                <textarea matInput formControlName="stepsToReproduce" rows="6" required></textarea>
                <mat-hint class="hint">Steps to follow to reproduce the bug.</mat-hint>
                <mat-error *ngIf="f.stepsToReproduce.touched && f.stepsToReproduce.invalid && f.stepsToReproduce.pristine">
                  <strong>Required</strong>
                </mat-error>
                <mat-error *ngIf="!f.stepsToReproduce.valid && (f.stepsToReproduce.touched && f.stepsToReproduce.dirty)">
                  <strong>Required</strong>
                </mat-error>
              </mat-form-field>
              <div class="example-full-width">
                <input class="file-upload" formControlName="file" id="file" type="file" multiple=""
                       (change)="onFileChange($event)" accept="image/*">
                <br />
                <small class="text-muted">*Please attach a screenshot(s) of the bug.</small>
                <br />
                <img class="display-files" *ngFor="let url of images" [src]="url" height="150" width="150">
                <br />
              </div>
            </div>
          </mat-card-content>

          <div class="text-center sv-up-dt">
            <button  class="mat-btn btn-danger" mat-raised-button cdkFocusInitial [disabled]="reportBugForm.invalid">
              Submit
            </button>
          </div>
        </mat-card>
      </div>
    </form>
  </div>
</div>
